module.exports = __webpack_public_path__ + "img/mission_attend.6e8a1d4.svg";